export default "__VITE_ASSET__tNe5kbwe__"